import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextareaAutosize } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '~/theme/default';
const StyledTextarea = styled(TextareaAutosize)(() => `
    font-family: Roboto, sans-serif;
    font-weight: 400;
    padding: 16px;
    font-size: 16px;
    color: ${theme.palette.info.dark};
    border: 1px solid ${theme.palette.grey.A200};
    border-radius: 4px;

    // firefox
    &:focus-visible {
      outline: 0;
    }
  `);
export function FormikTextarea({ formikProps, name, placeholder, minRows = 3, }) {
    const { handleChange, values } = formikProps;
    return (_jsx(StyledTextarea, { sx: {
            '::placeholder': {
                opacity: 0.64,
                color: theme.palette.info.dark,
            },
        }, minRows: minRows, name: name, value: values[name] || '', placeholder: placeholder, onChange: handleChange }, name));
}
